"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var useAnimations_1 = __importDefault(require("./useAnimations"));
// noinspection JSUnusedGlobalSymbols
function useAnimation(predicate) {
    var animations = (0, useAnimations_1.default)();
    return animations.find(function (animation) { return !predicate || predicate(animation); });
}
exports.default = useAnimation;
//# sourceMappingURL=useAnimation.js.map